import { Component } from '@angular/core';

@Component({
    selector: 'app-capnography-section',
    templateUrl: './capnography-section.component.html',
    styleUrls: ['./capnography-section.component.css'],
    standalone: false
})
export class CapnographySectionComponent {}
